var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallAvatarGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_60451)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.4825,
    r: 22,
    fill: "url(#paint0_linear_820_60451)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.4825,
    r: 21,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_820_60451",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44.4825C34.1503 44.4825 44 34.6328 44 22.4825C44 10.3323 34.1503 0.482544 22 0.482544C9.84974 0.482544 0 10.3323 0 22.4825C0 34.6328 9.84974 44.4825 22 44.4825Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 29.8159C27.0626 29.8159 31.1667 25.7118 31.1667 20.6492C31.1667 15.5866 27.0626 11.4825 22 11.4825C16.9374 11.4825 12.8333 15.5866 12.8333 20.6492C12.8333 25.7118 16.9374 29.8159 22 29.8159Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2875 38.845C8.66688 36.1281 10.7717 33.8462 13.3685 32.2522C15.9654 30.6582 18.953 29.8159 22 29.8159C25.0471 29.8159 28.0346 30.6582 30.6315 32.2522C33.2283 33.8462 35.3331 36.1281 36.7125 38.845"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.39583 38.3924C6.14582 38.8848 6.34235 39.4867 6.83481 39.7367C7.32726 39.9867 7.92915 39.7902 8.17917 39.2977L6.39583 38.3924ZM35.8208 39.2977C36.0709 39.7902 36.6727 39.9867 37.1652 39.7367C37.6576 39.4867 37.8542 38.8848 37.6042 38.3924L35.8208 39.2977ZM43 22.4825C43 34.0805 33.598 43.4825 22 43.4825V45.4825C34.7025 45.4825 45 35.1851 45 22.4825H43ZM22 43.4825C10.402 43.4825 1 34.0805 1 22.4825H-1C-1 35.1851 9.29745 45.4825 22 45.4825V43.4825ZM1 22.4825C1 10.8846 10.402 1.48254 22 1.48254V-0.517456C9.29745 -0.517456 -1 9.77999 -1 22.4825H1ZM22 1.48254C33.598 1.48254 43 10.8846 43 22.4825H45C45 9.77999 34.7025 -0.517456 22 -0.517456V1.48254ZM30.1667 20.6492C30.1667 25.1595 26.5103 28.8159 22 28.8159V30.8159C27.6149 30.8159 32.1667 26.2641 32.1667 20.6492H30.1667ZM22 28.8159C17.4897 28.8159 13.8333 25.1595 13.8333 20.6492H11.8333C11.8333 26.2641 16.3851 30.8159 22 30.8159V28.8159ZM13.8333 20.6492C13.8333 16.1389 17.4897 12.4825 22 12.4825V10.4825C16.3851 10.4825 11.8333 15.0343 11.8333 20.6492H13.8333ZM22 12.4825C26.5103 12.4825 30.1667 16.1389 30.1667 20.6492H32.1667C32.1667 15.0343 27.6149 10.4825 22 10.4825V12.4825ZM8.17917 39.2977C9.47495 36.7454 11.4522 34.6018 13.8917 33.1045L12.8454 31.3999C10.0912 33.0905 7.85881 35.5107 6.39583 38.3924L8.17917 39.2977ZM13.8917 33.1045C16.3309 31.6072 19.1373 30.8159 22 30.8159V28.8159C18.7686 28.8159 15.5999 29.7092 12.8454 31.3999L13.8917 33.1045ZM22 30.8159C24.8627 30.8159 27.6691 31.6072 30.1083 33.1045L31.1546 31.3999C28.4001 29.7092 25.2314 28.8159 22 28.8159V30.8159ZM30.1083 33.1045C32.5478 34.6018 34.5251 36.7454 35.8208 39.2977L37.6042 38.3924C36.1412 35.5107 33.9088 33.0905 31.1546 31.3999L30.1083 33.1045Z",
    fill: "white",
    mask: "url(#path-3-inside-1_820_60451)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.4825,
    r: 21,
    stroke: "#C8E5BB",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_820_60451",
    x1: 7.7,
    y1: -7.58412,
    x2: 34.4667,
    y2: 49.2492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519834"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_60451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 0.482544)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAvatarGreen);
export default __webpack_public_path__ + "static/media/small-avatar-green.da114091fb7ecddae22a956f331e3c6e.svg";
export { ForwardRef as ReactComponent };